import {Dispatch, SetStateAction} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
}

const CancelLoanBottomSheet = ({isOpen, setIsOpen, onConfirm}: IProps) => {
  return (
    <BottomSheet
      open={isOpen}
      blocking
      className="custom-bottom-sheet"
      onDismiss={() => setIsOpen(false)}
    >
      <div className="relative flex flex-col w-full gap-2 p-6 min-h-16">
        <div
          className="flex items-center gap-2 text-red-500 cursor-pointer"
          onClick={e => {
            e.stopPropagation();
            onConfirm();
            setIsOpen(false);
          }}
        >
          <i className="icon-nameClose-remove" />
          <span className="text-md">لغو درخواست</span>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CancelLoanBottomSheet;
